module.exports = __webpack_public_path__ + "img/selected4-min.c3e50a12.png";